import { CheckName } from "../../types/incidentbanner.typer";

const incidents = {
  banner: {
    message_zero:
      "Vi har for øyblikket ustabilitet i applikasjonen. Vi jobber med å løse problemet.",
    message_one:
      "Vi har for øyeblikket ustabilitet mot $t(services.{{service}}). Prøv igjen senere.",
    message_other:
      "Vi har for øyeblikket ustabilitet mot {{services, services_formatter}}. Prøv igjen senere.",
  },
  services: {
    FREG: "folkeregisteret",
    BRREG: "brønnøysundregistrene",
    KARTVERKET: "kartverket",
    ALTINN: "altinn",
    VEGVESEN: "statens vegvesen",
  } satisfies Record<CheckName, string>,
  og: "og",
};
export default incidents;
